'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Badge = exports.Badge = (0, _components2["default"])({
  fontSize: 0,
  px: 2,
  py: 1,
  mx: 1,
  color: 'white',
  bg: 'blue',
  fontWeight: 'bold',
  borderRadius: 2
}, {
  WebkitFontSmoothing: 'antialiased',
  display: 'inline-block',
  verticalAlign: 'middle'
}, 'space', 'color', 'fontSize', 'fontWeight', 'borderRadius');
Badge.displayName = 'Badge';
exports["default"] = Badge;